import React, { useMemo } from 'react';

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import SurchargeMonthSeasonRow from './SurchargeMonthSeasonRow';
import { percentDaysSurcharged } from './surchargeGridsModel';
import type { SeasonLabel, SurchargeGrids, TravelMonth } from './types';

interface Props {
  grids: SurchargeGrids;
  months: ReadonlyArray<TravelMonth>;
  onMonthSeasonChange: (monthKey: string, season: SeasonLabel | null) => void;
}

export default function SurchargeSeasonalityTable({ grids, months, onMonthSeasonChange }: Props) {
  const percentByMonth = useMemo(
    () => Object.fromEntries(months.map((month) => [month.key, percentDaysSurcharged(month.key, grids)])),
    [grids, months],
  );

  return (
    <TableContainer sx={{ overflowX: 'auto' }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 700 }}>Month</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Season</TableCell>
            <TableCell align="right" sx={{ fontWeight: 700 }}>
              % Days Surcharged
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {months.map((month) => (
            <SurchargeMonthSeasonRow
              key={month.key}
              month={month}
              onChange={onMonthSeasonChange}
              percentSurcharged={percentByMonth[month.key]}
              season={grids.seasonByMonth[month.key]}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
